import React, { forwardRef } from 'react';

const UICardBackground = ({ width, height, href, ...rest }, ref) => (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <image href={href} x="0" y="0" width={width} height={height} {...rest} />
    </svg>
);

export default forwardRef(UICardBackground);
